import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import {
  addDoc,
  collection,
  doc,
  getDoc,
  onSnapshot,
  query,
  Timestamp,
  where,
} from "firebase/firestore";
import { auth, db } from "../firebase";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import moment from "moment";

export default function Javakregister() {
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  // 🔹 States
  const [departments, setDepartments] = useState([]);
  const [products, setProducts] = useState([]);
  const [javakitems, setJavakitems] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [quantity, setQuantity] = useState(0);
  const [size, setSize] = useState("");
  const [rate, setRate] = useState(0);

  const [username, setUsername] = useState("");
  const [userData, setUserData] = useState(null);

  const [javakdate, setJavakdate] = useState(moment().format("YYYY-MM-DD"));
  const [javakpersonname, setJavakpersonname] = useState("");
  const [javaknote, setJavaknote] = useState("");

  // 🔹 Fetch User Info
  useEffect(() => {
    const unsub = auth.onAuthStateChanged((user) => {
      setUserData(user);
      if (user) fetchUser(user);
    });
    return () => unsub();
  }, []);

  const fetchUser = async (user) => {
    try {
      const docRef = doc(db, "users", user.uid);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setUsername(docSnap.data().username || "");
      }
    } catch (err) {
      console.log(err);
    }
  };

  // 🔹 Fetch Departments
  useEffect(() => {
    const q = query(collection(db, "departments"));
    const unsub = onSnapshot(q, (snapshot) => {
      setDepartments(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    });
    return () => unsub();
  }, []);

  // 🔹 Fetch Products by Department
  useEffect(() => {
    // if (!selectedDepartment) {
    //   setProducts([]);
    //   setSelectedProduct(null);
    //   return;
    // }

    const q = query(
      collection(db, "products"),
      // where("departmentid", "==", selectedDepartment.id)
    );

    const unsub = onSnapshot(q, (snapshot) => {
      setProducts(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    });

    return () => unsub();
  }, [selectedDepartment]);

  // 🔹 Add Item
  const handleAddItem = () => {
    if ( !selectedProduct) {
      Toast.fire({ icon: "error", title: "Department & Product are required" });
      return;
    }

    const newItem = {
      // department: selectedDepartment.department,
      // departmentId: selectedDepartment.id,
      product: selectedProduct.product,
      productid: selectedProduct.id,
      quantity,
      size,
      username,
    };

    setJavakitems([...javakitems, newItem]);
    setSelectedProduct(null);
    setQuantity(0);
    setSize("");
    setRate(0);
  };

  // 🔹 Remove Item
  const removeItem = (itemToRemove) => {
    if (window.confirm("Are you sure you want to remove this item?")) {
      setJavakitems(javakitems.filter((item) => item !== itemToRemove));
    }
  };

  // 🔹 Submit Data
  const submitData = async () => {
    if (!javakitems.length) {
      Toast.fire({ icon: "error", title: "Add at least one product" });
      return;
    }

    try {
      const docRef = await addDoc(collection(db, "javakregisters"), {
        javakitems,
        javakdate,
        javakpersonname,
        javaknote,
        uid: userData.uid,
        createdAt: Timestamp.now(),
      });

      // Save each item
      for (let item of javakitems) {
        await addDoc(collection(db, "javakitems"), {
          javakid: docRef.id,
          ...item,
          quantity: parseFloat(item.quantity),
          createdAt: Timestamp.now(),
          javakdate,
        });
      }

      Toast.fire({ icon: "success", title: "Javak Data successfully added" });

      // reset
      setJavakitems([]);
      setSelectedDepartment(null);
      setSelectedProduct(null);
      setQuantity(0);
      setSize("");
      setRate(0);
      setJavakdate(moment().format("YYYY-MM-DD"));
      setJavakpersonname("");
      setJavaknote("");
    } catch (err) {
      Toast.fire({ icon: "error", title: "Error: " + err.message });
    }
  };

  // 🔹 UI
  return (
    <div className="content-wrapper" style={{ backgroundColor: "#fff" }}>
      <section className="content">
        <br />
        <div className="container-fluid">
          <button className="btn btn-secondary">|| Javak Register ||</button>
          <br /><br />

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <table className="table table-bordered align-middle">
                    <thead className="table-light">
                      <tr>
                        {/* <th>Department</th> */}
                        <th>Product</th>
                        <th>Quantity</th>
                        <th>Size</th>
                        {/* <th>Rate</th> */}
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        {/* <td>
                          <Autocomplete
                            options={departments}
                            getOptionLabel={(option) => option.department || ""}
                            value={selectedDepartment}
                            onChange={(e, newValue) => setSelectedDepartment(newValue)}
                            renderInput={(params) => (
                              <TextField {...params} label="Department" size="small" fullWidth />
                            )}
                          />
                        </td> */}
                        <td>
                          <Autocomplete
                            options={products}
                            getOptionLabel={(option) => option.product || ""}
                            value={selectedProduct}
                            onChange={(e, newValue) => setSelectedProduct(newValue)}
                            renderInput={(params) => (
                              <TextField {...params} label="Product" size="small" fullWidth />
                            )}
                            // disabled={!selectedDepartment}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                          />
                        </td>
                        <td>
                          <TextField
                            type="number"
                            value={quantity}
                            onChange={(e) => setQuantity(e.target.value)}
                            size="small"
                            fullWidth
                          />
                        </td>
                        <td>
                          <TextField
                            type="text"
                            value={size}
                            onChange={(e) => setSize(e.target.value)}
                            size="small"
                            fullWidth
                          />
                        </td>
                       
                        <td className="text-center">
                          <Button variant="contained" size="small" onClick={handleAddItem}>
                            Add
                          </Button>
                        </td>
                      </tr>

                      {javakitems.map((item, index) => (
                        <tr key={index}>
                          {/* <td><input type="text" readOnly value={item.department} className="form-control form-control-sm" /></td> */}
                          <td><input type="text" readOnly value={item.product} className="form-control form-control-sm" /></td>
                          <td><input type="text" readOnly value={item.quantity} className="form-control form-control-sm" /></td>
                          <td><input type="text" readOnly value={item.size} className="form-control form-control-sm" /></td>
                          {/* <td><input type="text" readOnly value={item.rate} className="form-control form-control-sm" /></td> */}
                          <td className="text-center">
                            <Button color="error" size="small" onClick={() => removeItem(item)}>Remove</Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          {/* Extra Fields */}
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-sm-4">
                  <TextField
                    label="Javak Date"
                    type="date"
                    value={javakdate}
                    onChange={(e) => setJavakdate(e.target.value)}
                    size="small"
                    fullWidth
                  /><br /><br />
                </div>
                <div className="col-sm-4">
                  <TextField
                    label="Javak Person Name"
                    value={javakpersonname}
                    onChange={(e) => setJavakpersonname(e.target.value)}
                    size="small"
                    fullWidth
                  /><br /><br />
                </div>
                <div className="col-sm-4">
                  <TextField
                    label="Javak Note"
                    value={javaknote}
                    onChange={(e) => setJavaknote(e.target.value)}
                    fullWidth
                  /><br /><br />
                </div>
              </div>
            </div>
          </div>

          <center>
            <Button variant="contained" onClick={submitData}>
              Submit
            </Button>
          </center>
        </div>
      </section>
    </div>
  );
}
